/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlZeroDayAlertClientNotificationEvent } from './ControlZeroDayAlertClientNotificationEvent';
import {
    ControlZeroDayAlertClientNotificationEventFromJSON,
    ControlZeroDayAlertClientNotificationEventFromJSONTyped,
    ControlZeroDayAlertClientNotificationEventToJSON,
} from './ControlZeroDayAlertClientNotificationEvent';
import type { ControlZeroDayAlertEscalationStatus } from './ControlZeroDayAlertEscalationStatus';
import {
    ControlZeroDayAlertEscalationStatusFromJSON,
    ControlZeroDayAlertEscalationStatusFromJSONTyped,
    ControlZeroDayAlertEscalationStatusToJSON,
} from './ControlZeroDayAlertEscalationStatus';
import type { ControlZeroDayAlertResolutionStatus } from './ControlZeroDayAlertResolutionStatus';
import {
    ControlZeroDayAlertResolutionStatusFromJSON,
    ControlZeroDayAlertResolutionStatusFromJSONTyped,
    ControlZeroDayAlertResolutionStatusToJSON,
} from './ControlZeroDayAlertResolutionStatus';

/**
 * 
 * @export
 * @interface ControlZeroDayAlertClientAssociation
 */
export interface ControlZeroDayAlertClientAssociation {
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientAssociation
     */
    zero_day_alert_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientAssociation
     */
    client_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientAssociation
     */
    org_id?: string;
    /**
     * 
     * @type {ControlZeroDayAlertResolutionStatus}
     * @memberof ControlZeroDayAlertClientAssociation
     */
    resolution_status?: ControlZeroDayAlertResolutionStatus;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientAssociation
     */
    resolved_by?: string;
    /**
     * 
     * @type {number}
     * @memberof ControlZeroDayAlertClientAssociation
     */
    resolved_version?: number;
    /**
     * 
     * @type {ControlZeroDayAlertEscalationStatus}
     * @memberof ControlZeroDayAlertClientAssociation
     */
    escalation_status?: ControlZeroDayAlertEscalationStatus;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientAssociation
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientAssociation
     */
    assignee?: string;
    /**
     * 
     * @type {ControlZeroDayAlertClientNotificationEvent}
     * @memberof ControlZeroDayAlertClientAssociation
     */
    last_notification_event?: ControlZeroDayAlertClientNotificationEvent;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ControlZeroDayAlertClientAssociation
     */
    impacted_assets?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlZeroDayAlertClientAssociation
     */
    resolved_assets?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ControlZeroDayAlertClientAssociation
     */
    exposure_usd?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlZeroDayAlertClientAssociation
     */
    created: string;
}

/**
 * Check if a given object implements the ControlZeroDayAlertClientAssociation interface.
 */
export function instanceOfControlZeroDayAlertClientAssociation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "zero_day_alert_id" in value;
    isInstance = isInstance && "client_id" in value;
    isInstance = isInstance && "created" in value;

    return isInstance;
}

export function ControlZeroDayAlertClientAssociationFromJSON(json: any): ControlZeroDayAlertClientAssociation {
    return ControlZeroDayAlertClientAssociationFromJSONTyped(json, false);
}

export function ControlZeroDayAlertClientAssociationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlZeroDayAlertClientAssociation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'zero_day_alert_id': json['zero_day_alert_id'],
        'client_id': json['client_id'],
        'org_id': !exists(json, 'org_id') ? undefined : json['org_id'],
        'resolution_status': !exists(json, 'resolution_status') ? undefined : ControlZeroDayAlertResolutionStatusFromJSON(json['resolution_status']),
        'resolved_by': !exists(json, 'resolved_by') ? undefined : json['resolved_by'],
        'resolved_version': !exists(json, 'resolved_version') ? undefined : json['resolved_version'],
        'escalation_status': !exists(json, 'escalation_status') ? undefined : ControlZeroDayAlertEscalationStatusFromJSON(json['escalation_status']),
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'assignee': !exists(json, 'assignee') ? undefined : json['assignee'],
        'last_notification_event': !exists(json, 'last_notification_event') ? undefined : ControlZeroDayAlertClientNotificationEventFromJSON(json['last_notification_event']),
        'impacted_assets': !exists(json, 'impacted_assets') ? undefined : json['impacted_assets'],
        'resolved_assets': !exists(json, 'resolved_assets') ? undefined : json['resolved_assets'],
        'exposure_usd': !exists(json, 'exposure_usd') ? undefined : json['exposure_usd'],
        'created': json['created'],
    };
}

export function ControlZeroDayAlertClientAssociationToJSON(value?: ControlZeroDayAlertClientAssociation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'zero_day_alert_id': value.zero_day_alert_id,
        'client_id': value.client_id,
        'org_id': value.org_id,
        'resolution_status': ControlZeroDayAlertResolutionStatusToJSON(value.resolution_status),
        'resolved_by': value.resolved_by,
        'resolved_version': value.resolved_version,
        'escalation_status': ControlZeroDayAlertEscalationStatusToJSON(value.escalation_status),
        'notes': value.notes,
        'assignee': value.assignee,
        'last_notification_event': ControlZeroDayAlertClientNotificationEventToJSON(value.last_notification_event),
        'impacted_assets': value.impacted_assets,
        'resolved_assets': value.resolved_assets,
        'exposure_usd': value.exposure_usd,
        'created': value.created,
    };
}

